import { Button, makeStyles } from "@material-ui/core";

import * as colors from "../../../theme/colors";
import { StyledTopMenuItem } from "./styled-top-menu-item";

export const TopMenuButton = ({
  isRendered = true,
  onClick,
  className = "",
  isCurrent,
  children,
  selected,
  ...restButtonProps
}) => {
  const menuClasses = useStyles();

  if (!isRendered) {
    return null;
  }

  return (
    <StyledTopMenuItem disableRipple onClick={onClick} className={className}>
      <Button
        color="inherit"
        className={menuClasses.navButton}
        disableRipple
        role="navigation"
        selected={selected}
        {...restButtonProps}
      >
        {children}
        {isCurrent && <div className={menuClasses.menuCurrentPage} />}
      </Button>
    </StyledTopMenuItem>
  );
};

const useStyles = makeStyles(() => ({
  navButton: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: "none",
    cursor: "pointer",
    width: "100%",
    height: "100%",
    display: "flex",
    padding: 0,
    textTransform: "uppercase",
    color: colors.darkBlue900,
    "& .MuiButton-label": {
      justifyContent: "left",
    },
    "&:hover, &:active": {
      background: "transparent",
      color: colors.darkThemeGreen,
    },
    "&:focus": {
      background: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },
  menuCurrentPage: {
    width: "100%",
    height: 4,
    background: colors.darkThemeGreen,
    position: "absolute",
    bottom: -6,
  },
}));
